<div class="header-container">
  <span class="mat-subtitle-1" i18n>Overview</span>
  <button mat-icon-button [matMenuTriggerFor]="menu" class="!flex" i18n-aria-label aria-label="toggle button">
    <mat-icon>more_vert</mat-icon>
  </button>
  <mat-menu #menu="matMenu">
    <button mat-menu-item (click)="drawer.toggle()" i18n i18n-aria-label aria-label="inner toggle button">Display
      Columns</button>
  </mat-menu>
</div>

<mat-drawer-container class="container-drawer !z-10" [hasBackdrop]="drawer.opened">
  <mat-drawer #drawer mode="side" position="end">
    <div class=" ml-2 drawer-heared">
      <button mat-icon-button id="customViewCloseButton" (click)="drawer.toggle()" class="!flex items-center">
        <mat-icon>close</mat-icon>
      </button>
      <h2 class="drawer-title mat-subtitle-1" i18n>Customize view</h2>
    </div>
    <mat-list>
      @for(column of columns(); track column.columnDef) {
        <mat-list-item>
          <mat-checkbox [disabled]="column.alwaysVisible ?? false" [(ngModel)]="column.visible" color="primary"
            (change)="onVisibilityChange(column.columnDef)" class="drawer-item">{{
            column.header
            }}</mat-checkbox>
        </mat-list-item>
      }
    </mat-list>
  </mat-drawer>

</mat-drawer-container>